"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _view = require("../constants/view");

var _filters = require("../constants/filters");

var _environment = require("../constants/environment");

var _Performance = _interopRequireDefault(require("./Performance"));

var _PropTypes$shape;

var PerformanceNetwork = function PerformanceNetwork(props) {
  return /*#__PURE__*/_react["default"].createElement(_Performance["default"], (0, _extends2["default"])({}, props, {
    view: _view.COMPONENT_VIEW.NETWORK
  }));
};

PerformanceNetwork.propTypes = {
  accessToken: _propTypes["default"].string.isRequired,
  environment: _propTypes["default"].oneOf([_environment.ENVIRONMENT.STAGING, _environment.ENVIRONMENT.PRODUCTION]),
  filters: _propTypes["default"].shape((_PropTypes$shape = {}, (0, _defineProperty2["default"])(_PropTypes$shape, _filters.FILTER_NAMES.MERCHANT, _propTypes["default"].arrayOf(_propTypes["default"].shape({
    merchantId: _propTypes["default"].string.isRequired,
    displayName: _propTypes["default"].string.isRequired
  }))), (0, _defineProperty2["default"])(_PropTypes$shape, _filters.FILTER_NAMES.FULFILLER, _propTypes["default"].arrayOf(_propTypes["default"].shape({
    fulfillerId: _propTypes["default"].string.isRequired,
    name: _propTypes["default"].string.isRequired
  }))), _PropTypes$shape)),
  onChangeFilters: _propTypes["default"].func,
  hideHeading: _propTypes["default"].bool,
  hideFilters: _propTypes["default"].bool,
  componentHeight: _propTypes["default"].string
};
var _default = PerformanceNetwork;
exports["default"] = _default;